jQuery(function ($) {
  const url = "https://accesspass.io";

  $('#register_user').submit(function (e) {
    e.preventDefault();
    // $('#register_user :input').prop('disabled', true);
    console.log('hi');
    const formData = $(this).serializeArray();
    const jsonData = {};

    $.each(formData, function (index, field) {
      jsonData[field.name] = field.value;
    });

    console.log(jsonData);
    registerUser(jsonData);

    //this will remove all error message upon submit of form
    $('.inputErrorText').html();
    $('.loader').addClass('active');
  })

  function registerUser(data) {

    // console.log('xxx', data);
    var settings = {
      "url": "https://accesspass.io/api/user/signup",
      "method": "POST",
      "timeout": 0,
      "headers": {
        "Accept": "application/json",
        "Api-Token": "eyJpdiI6ImtrTm0xTSsrTHBkdk5yMEJmcndSWHc9PSIsInZhbHVlIjoiWTJQS3ZRVDI3ai9RQ0RkUUZScEIzVE90V2VRbGFuWjh6dTVqYzRvSjVXRT0iLCJtYWMiOiI0MTM0MWYyMDZiNTMxZmE2YjZhMzgyNGMzOTdiZjkzOWE2OGI3YzIzOGZiMjA2OWE5YjIxYTNmNTMxODFkNWU4IiwidGFnIjoiIn0=",
        "Content-Type": "application/json"
      },
      "data": JSON.stringify(data),
      complete: function () {
        // Re-enable form fields after AJAX is complete
        $('#register_user :input').prop('disabled', false);
      },
      error: function (error) {
        // console.log()
        $('.loader').removeClass('active');
        const errorResponse = JSON.parse(error.responseText);
        // console.log({errorResponse})
        const errors = errorResponse.errors;
        for (const field in errors) {
          if (errors.hasOwnProperty(field)) {
            const errorMessages = errors[field];
            let message = '';
            console.log(`${field}:`);
            errorMessages.forEach(errorMessage => {
              console.log(`- ${errorMessage}`);
              message += errorMessage;
            });
            $(`#error_${field}`).html(message);
          }
        }
      }
    };

    $.ajax(settings).done(function (response) {
      console.log(response);

      if (response.success) {
        $('#register_user').hide();
        $('.register-success').show();
      } else {
        $('#error_email').html(response.message);
        $('.loader').removeClass('active');
      }
    });

    $('.loader').removeClass('active');


  }
});
